<template>
  <v-container>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>User Management</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon="mdi-refresh" @click="fetchUsers" :loading="loading"></v-btn>
      </v-toolbar>
        <v-card-text>
            <v-table>
                <thead>
                    <tr>
                        <th>Avatar</th>
                        <th>ID</th>
                        <th>Username</th>
                        <th>Role</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in users" :key="item.id">
                        <td>
                            <v-avatar size="32">
                                <v-img :src="item.avatar ? `https://cdn.discordapp.com/avatars/${item.id}/${item.avatar}.png` : ''" cover></v-img>
                            </v-avatar>
                        </td>
                        <td>{{ item.id }}</td>
                        <td>{{ item.username }}</td>
                        <td>
                              <v-select
                                v-model="item.role"
                                :items="roles"
                                item-title="title"
                                item-value="value"
                                density="compact"
                                hide-details
                                variant="outlined"
                                style="width: 150px"
                                @update:modelValue="(val: any) => updateRole(item, val)"
                            ></v-select>
                        </td>
                        <td>
                            <v-btn icon="mdi-delete" color="error" size="small" variant="text" @click="deleteUser(item)"></v-btn>
                        </td>
                    </tr>
                </tbody>
            </v-table>
        </v-card-text>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';

export default defineComponent({
  name: 'Admin',
  setup() {
    const users = ref<any[]>([]);
    const loading = ref(false);
    
    const roles = [
      { title: 'Pending', value: 0 },
      { title: 'User', value: 1 },
      { title: 'Advanced', value: 2 },
      { title: 'Admin', value: 3 },
    ];

    const fetchUsers = async () => {
      loading.value = true;
      try {
        const res = await fetch('/api/users');
        if (!res.ok) throw new Error('Failed to fetch users');
        users.value = await res.json();
      } catch (e) {
        alert(e);
      } finally {
        loading.value = false;
      }
    };

    const updateRole = async (user: any, newRole: number) => {
      try {
        const res = await fetch('/api/users/role', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: user.id, role: newRole })
        });
        if (!res.ok) throw new Error('Failed to update role');
      } catch (e) {
        alert(e);
        fetchUsers();
      }
    };

    const deleteUser = async (user: any) => {
      if (!confirm(`Delete user ${user.username}?`)) return;
      try {
        const res = await fetch(`/api/users/delete?id=${user.id}`);
        if (!res.ok) throw new Error('Failed to delete user');
        users.value = users.value.filter(u => u.id !== user.id);
      } catch (e) {
        alert(e);
      }
    };

    onMounted(fetchUsers);

    return { users, loading, roles, updateRole, deleteUser, fetchUsers };
  }
});
</script>
